import type { HttpClient } from "../httpClient";
import {
    ReviewImportResponseSchema,
    type ReviewImportResponse,
    type ReviewImportStatus,
} from "../schemas/reviews-v2/import";

export interface ReviewImportParams {
    expertId: number | string;
    file: File;
    status?: ReviewImportStatus;
}

export function createAdminReviewsImportApi(http: HttpClient, baseUrl: string) {
    const adminBaseUrl = `${baseUrl}/admin/experts`;

    function buildFormData(file: File, status?: ReviewImportStatus): FormData {
        const formData = new FormData();
        formData.append("file", file);
        if (status) formData.append("status", status);
        return formData;
    }

    async function postFormData(
        path: string,
        file: File,
        status?: ReviewImportStatus,
    ): Promise<ReviewImportResponse> {
        const url = `${adminBaseUrl}${path}`;
        const response = await http.post<unknown, FormData>(
            url,
            buildFormData(file, status),
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            },
        );
        return ReviewImportResponseSchema.parse(response.data);
    }

    return {
        previewImport: async (params: ReviewImportParams): Promise<ReviewImportResponse> => {
            return postFormData(
                `/${params.expertId}/reviews-v2/import/preview`,
                params.file,
                params.status,
            );
        },

        runImport: async (params: ReviewImportParams): Promise<ReviewImportResponse> => {
            return postFormData(
                `/${params.expertId}/reviews-v2/import`,
                params.file,
                params.status,
            );
        },
    };
}

export type AdminReviewsImportApi = ReturnType<typeof createAdminReviewsImportApi>;
